import { useCallback, useEffect, useRef } from 'react';

export function useAutocompleteFocusBehavior({ dropdownOpened, setDropdownOpened, setFilteredOptions, options, fieldName }) {
    const wasThisInputFocusedAtWindowBlurRef = useRef(false);

    useEffect(() => {
        const onWindowBlur = () => {
            const ae = document.activeElement;
            if (ae instanceof HTMLInputElement && ae.name === fieldName) {
                wasThisInputFocusedAtWindowBlurRef.current = true;
            }
            setDropdownOpened(false);
        };
        window.addEventListener('blur', onWindowBlur);
        return () => window.removeEventListener('blur', onWindowBlur);
    }, [fieldName, setDropdownOpened]);

    const focusHandler = useCallback(
        (focused) => {
            if (focused && wasThisInputFocusedAtWindowBlurRef.current) {
                wasThisInputFocusedAtWindowBlurRef.current = false;
                return;
            }
            setDropdownOpened(focused);
            if (focused) {
                setFilteredOptions(options);
            }
        },
        [options, setDropdownOpened, setFilteredOptions]
    );

    const containerMouseDownHandler = useCallback(() => {
        if (dropdownOpened) return;
        wasThisInputFocusedAtWindowBlurRef.current = false;
        setDropdownOpened(true);
        setFilteredOptions(options);
    }, [dropdownOpened, options, setDropdownOpened, setFilteredOptions]);

    return { focusHandler, containerMouseDownHandler };
}
